<template>
    <div class="Summary" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Family Info</h4>
                        <p><span class="bold">Family Name: </span><span>{{ RecordData.Name }}</span></p>
                        <p><span class="bold">Territory: </span><span>{{ RecordData.SubProgramTerritory.Name }}</span></p>
                        <p><span class="bold">Address: </span><span v-if="PhysicalAddress">{{ PhysicalAddress.AddressSingleLine}}</span> <GoogleMapsLink v-if="PhysicalAddress" v-bind:address="PhysicalAddress" /></p>
                    </div>
                    
                </div>
                <!--<div class="col-md-4">
                    <div class="record-section">
                        <h4>People</h4>
                        <div v-for="client in RecordData.Clients">
                            <p><span class="bold">{{ client.Client.Person.FullName }}</span><span> ({{ client.Client.ClientType }})</span></p>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },

            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            
            PhysicalAddress: function () {
                let physicalAddresses = this.RecordData.AddressMemberships.filter(am => am.Address.Type == "Physical");
                if (physicalAddresses.length > 0) {
                    return physicalAddresses[0].Address;
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
</style>